"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableDefaultValue = void 0;
const react_1 = __importStar(require("react"));
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../../Colors");
const vars_1 = require("../../../../vars");
const index_1 = require("../../../DOM/index");
const Input = typestyle_1.style({
    border: 0,
    background: `${Colors_1.Colors.grey[10]}44`,
    borderRadius: 4,
    color: Colors_1.Colors.grey[0],
    minWidth: 30,
    fontFamily: vars_1.fontFamily,
    fontSize: 10,
    textAlign: 'center',
    padding: `2px 0`,
});
exports.EditableDefaultValue = ({ value, onChange, autoFocus, style = {}, }) => {
    const [editedValue, setEditedValue] = react_1.useState(value);
    const [focus, setFocus] = react_1.useState(!!autoFocus);
    const checkEdit = () => {
        setFocus(false);
        index_1.DOM.panLock = false;
        index_1.DOM.keyLock = false;
        if (onChange) {
            if (editedValue !== value) {
                onChange(editedValue);
            }
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { autoFocus: focus, className: Input, disabled: !onChange, value: editedValue, style: Object.assign({ width: `${editedValue.length + 3}ch` }, style), onFocus: () => {
                index_1.DOM.panLock = true;
                index_1.DOM.keyLock = true;
            }, onBlur: checkEdit, onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    checkEdit();
                }
            }, onChange: (e) => setEditedValue(e.target.value) })));
};
